import { useAuth } from '@/context/AuthContext';
import { LogOut, User, Bell, Shield } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';

const ROLE_COLORS = {
  admin: 'bg-[#C97A5E]/10 text-[#C97A5E]',
  manager: 'bg-blue-100 text-blue-800',
  accountant: 'bg-green-100 text-green-800'
};

export const Header = () => {
  const { admin, logout } = useAuth();

  return (
    <header className="h-16 bg-white border-b border-[#E5E5E5] px-8 flex items-center justify-between sticky top-0 z-40">
      <div>
        <h2 className="text-[#5C4033] font-semibold text-lg">Welcome back!</h2>
      </div>

      <div className="flex items-center gap-4">
        {/* Notifications */}
        <Button variant="ghost" size="icon" className="text-[#5C4033] hover:bg-[#FAFAF9]" data-testid="notifications-btn">
          <Bell className="w-5 h-5" />
        </Button>

        {/* Profile Dropdown */}
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button 
              variant="ghost" 
              className="flex items-center gap-3 hover:bg-[#FAFAF9] px-3"
              data-testid="profile-menu-trigger"
            >
              <div className="w-9 h-9 rounded-full bg-[#C97A5E] flex items-center justify-center text-white font-medium">
                {admin?.name?.charAt(0) || 'A'}
              </div>
              <div className="text-left hidden md:block">
                <p className="text-sm font-medium text-[#2D2420]">{admin?.name || 'Admin'}</p>
                <Badge className={`text-xs capitalize ${ROLE_COLORS[admin?.role] || ROLE_COLORS.accountant}`}>
                  {admin?.role || 'admin'}
                </Badge>
              </div>
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end" className="w-56">
            <DropdownMenuLabel>My Account</DropdownMenuLabel>
            <DropdownMenuSeparator />
            <DropdownMenuItem data-testid="profile-link">
              <User className="mr-2 h-4 w-4" />
              Profile
            </DropdownMenuItem>
            <DropdownMenuItem>
              <Shield className="mr-2 h-4 w-4" />
              <span className="capitalize">{admin?.role || 'admin'}</span>
            </DropdownMenuItem>
            <DropdownMenuSeparator />
            <DropdownMenuItem 
              onClick={logout} 
              className="text-red-600 focus:text-red-600"
              data-testid="logout-btn"
            >
              <LogOut className="mr-2 h-4 w-4" />
              Logout
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    </header>
  );
};
